<div class="headerMainDiv">
    <div class="airaHeaderLogo">
        <!-- <mat-icon svgIcon="logo"></mat-icon> -->
        <img [src]="'../../'+appConfig.appBaseName+'assets/images/svg/airaLogo.svg'" alt="Aira Logo"
            aria-label="Aira Logo" class="airaLogo" />
        <img [src]="'../../'+appConfig.appBaseName+'assets/images/svg/login/' + appConfig.projectLogo" alt="Aira Logo"
            aria-label="Aira Logo" class="airaProjectTitle" />
    </div>
    <div class="rightSideHeader">
        <mat-icon class="dn" (click)="changeToken()">change_history</mat-icon>
        <mat-form-field class="filter_bg" [style]="{'margin-right': '1vw'}">
            <mat-select class="select-panel" [(ngModel)]="userRole" (selectionChange)="changeRole()">
                <mat-option *ngFor="let indvUserRole of roles" [value]="indvUserRole.role">
                    {{indvUserRole.roleDisplayText | titlecase}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <div class="circle cursorPointer" [ngStyle]="{'background-color': circleColor}">
            <div class="initials">{{initials}}</div>
        </div>
        <div class="usernm_header"> Hello {{firstName}} {{lastName}} </div>
        <mat-icon class="logouticon cursorPointer" svgIcon="userProfile" (click)="logout()"></mat-icon>
        <!-- <img src="../../assets/images/logoutIcon.svg" alt="Logout" aria-label="Logout" class="logouticon"
            (click)="logout()" /> -->
        <mat-menu #beforeMenu="matMenu" xPosition="before">
            <button mat-menu-item (click)="changePassword()">Change Password</button>
            <button mat-menu-item (click)="logout()">Logout</button>
        </mat-menu>
    </div>
</div>